import React, { useEffect, useState } from 'react'
import '../../../scss/_invoice.scss'

export default function FacturaTemplate(props) {


    const [invoiceDate, setInvoiceDate] = useState()
    const [invoiceNumber, setInvoiceNumber] = useState()
    const [currencySymbol, setCurrencySymbol] = useState("$")
    const [img, setImg] = useState("$")

    // detail info
    const [cant, setCant] = useState()
    const [detail, setDetail] = useState()
    const [precio, setPrecio] = useState()
    const [discount, setDiscount] = useState()
    const [subTotal, setSubTotal] = useState()
    const [iva, setIVA] = useState()
    const [Total, setTotal] = useState()
    const [customer, setCustomer] = useState({
        client: "",
        identification: "",
        name: "",
        phone: "",
        address1: ""
    });
    const [bussiness, setBussines] = useState({
        client: "",
        identification: "",
        phone: "",
        address1: ""
    });

    useEffect(() => {
        if (props) {
            const invoiceData = props.formData
            setInvoiceDate(invoiceData.fecha_emision)
            setInvoiceNumber(invoiceData.numero_factura)
            setCurrencySymbol("$")
            setImg(invoiceData.bimg)
            // set detail
            setCant(invoiceData.cantidad)
            setDetail(invoiceData.observation + ' ' + invoiceData.code)
            setPrecio(invoiceData.precio_unitario)
            setDiscount(invoiceData.descuento)
            setSubTotal(invoiceData.subtotal)
            setIVA(invoiceData.iva)
            setTotal(invoiceData.total)

            // Información del cliente
            setCustomer({
                client: "Datos del cliente",
                identification: invoiceData.identification,
                name: invoiceData.name + ' ' + invoiceData.last_name,
                email: invoiceData.email,
                phone: invoiceData.phone,
                address1: invoiceData.direction
            });

            // información de la empresa
            setBussines({
                client: invoiceData.bname,
                ruc: invoiceData.ruc,
                email: invoiceData.bemail,
                phone: invoiceData.bphone,
                address1: invoiceData.bdirection
            });

        }
    }, [props]) // Agrega `param.moduleId` como dependencia si es necesario

    // Calcular subtotales según IVA
    const subtotal0 = props.formData?.invoiceDetail?.reduce((sum, item) =>
        sum + (parseFloat(item.iva || 0) === 0 ? parseFloat(item.subtotal || 0) : 0), 0) || 0;

    const subtotal15 = props.formData?.invoiceDetail?.reduce((sum, item) =>
        sum + (parseFloat(item.iva || 0) > 0 ? parseFloat(item.subtotal || 0) : 0), 0) || 0;

    // Calcular descuento, IVA y total
    const descuento = props.formData?.invoiceDetail?.reduce((sum, item) =>
        sum + parseFloat(item.descuento || 0), 0) || 0;

    const ivaDet = props.formData?.invoiceDetail?.reduce((sum, item) =>
        sum + (parseFloat(item.iva || 0) > 0 ? parseFloat(item.iva || 0) : 0), 0) || 0;

    const total = props.formData?.invoiceDetail?.reduce((sum, item) =>
        sum + parseFloat(item.total || 0), 0) || 0;



    return (
        <>
            <div className="d-flex justify-content-center">
                <section className="content">
                    <div className="card">
                        <div className="card-body">
                            <div className="py-4">
                                <div className="px-14 py-6">
                                    <table className="w-full border-collapse border-spacing-0">
                                        <tbody>
                                            <tr>
                                                <td className="w-full align-top">
                                                    <div>
                                                        <img
                                                            src={global.IMGPerfil + img}
                                                            className="h-12"
                                                            alt="Brand Logo"
                                                        />
                                                    </div>
                                                </td>
                                                <td className="align-top">
                                                    <div className="text-sm">
                                                        <table className="border-collapse border-spacing-0">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="border-r pr-4">
                                                                        <div>
                                                                            <p className="whitespace-nowrap text-slate-400 text-right">Fecha</p>
                                                                            <p className="whitespace-nowrap font-bold text-main text-right">
                                                                                {new Date(invoiceDate).toLocaleDateString("es-EC", {
                                                                                    year: "numeric",
                                                                                    month: "long",
                                                                                    day: "numeric",
                                                                                })}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td className="pl-4">
                                                                        <div>
                                                                            <p className="whitespace-nowrap text-slate-400 text-right">Factura #</p>
                                                                            <p className="whitespace-nowrap font-bold text-main text-right">
                                                                                {invoiceNumber}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="bg-slate-100 px-14 py-6 text-sm">
                                    <table className="w-full border-collapse border-spacing-0">
                                        <tbody>
                                            <tr>
                                                <td className="w-1/2 align-top">
                                                    <div className="text-sm text-neutral-600">
                                                        {bussiness.client && <p className="font-bold">{bussiness.client}</p>}
                                                        {bussiness.ruc && <p>Identificación: {bussiness.ruc}</p>}
                                                        {bussiness.name && <p>Nombres: {bussiness.name}</p>}
                                                        {bussiness.email && <p>Correo: {bussiness.email}</p>}
                                                        {bussiness.phone && <p>Teléfono: {bussiness.phone}</p>}
                                                        {bussiness.address1 && <p>{bussiness.address1}</p>}
                                                    </div>
                                                </td>
                                                <td className="w-1/2 align-top text-right">
                                                    <div className="text-sm text-neutral-600">
                                                        {customer.client && <p className="font-bold">{customer.client}</p>}
                                                        {customer.identification && <p>Identificación: {customer.identification}</p>}
                                                        {customer.name && <p>Nombres: {customer.name}</p>}
                                                        {customer.email && <p>Correo: {customer.email}</p>}
                                                        {customer.phone && <p>Teléfono: {customer.phone}</p>}
                                                        {customer.address1 && <p>{customer.address1}</p>}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="px-14 py-10 text-sm text-neutral-700">
                                    <table className="w-full border-collapse border-spacing-0">
                                        <thead>
                                            <tr>
                                                <td className="border-b-2 border-main pb-3 pl-3 font-bold text-main">Cantidad</td>
                                                <td className="border-b-2 border-main pb-3 pl-2 font-bold text-main">Detalle</td>
                                                <td className="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Precio</td>
                                                <td className="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Desc.</td>
                                                <td className="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Subtotal</td>
                                                <td className="border-b-2 border-main pb-3 pl-2 text-right font-bold text-main">Total</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props.formData?.invoiceDetail?.map(item => (
                                                <tr key={item.id}>
                                                    <td className="border-b py-3 pl-3">{item.cantidad}.</td>
                                                    <td className="border-b py-3 pl-2">{item.nombre}</td>
                                                    <td className="border-b py-3 pl-2 text-right">
                                                        {currencySymbol}
                                                        {parseFloat(item.precio_unitario).toFixed(2)}
                                                    </td>
                                                    <td className="border-b py-3 pl-2 text-right">
                                                        {currencySymbol}
                                                        {parseFloat(item.descuento).toFixed(2)}
                                                    </td>
                                                    <td className="border-b py-3 pl-2 text-right">
                                                        {currencySymbol}
                                                        {parseFloat(item.precio_unitario_descuento).toFixed(2)}
                                                    </td>
                                                    <td className="border-b py-3 pl-2 text-right">
                                                        {currencySymbol}
                                                        {parseFloat(item.subtotal).toFixed(2)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="7">
                                                    <table className="w-full border-collapse border-spacing-0">
                                                        <tbody>
                                                            <tr>
                                                                <td className="w-full"></td>
                                                                <td>
                                                                    <table className="w-full border-collapse border-spacing-0">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="border-b p-3">
                                                                                    <div className="whitespace-nowrap text-slate-400">Subtotal 0%:</div>
                                                                                </td>
                                                                                <td className="border-b p-3 text-right">
                                                                                    <div className="whitespace-nowrap font-bold text-main">
                                                                                        {currencySymbol}
                                                                                        {parseFloat(subtotal0).toFixed(2)}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="border-b p-3">
                                                                                    <div className="whitespace-nowrap text-slate-400">Subtotal 15%:</div>
                                                                                </td>
                                                                                <td className="border-b p-3 text-right">
                                                                                    <div className="whitespace-nowrap font-bold text-main">
                                                                                        {currencySymbol}
                                                                                        {parseFloat(subtotal15).toFixed(2)}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="p-3">
                                                                                    <div className="whitespace-nowrap text-slate-400">Descuento:</div>
                                                                                </td>
                                                                                <td className="p-3 text-right">
                                                                                    <div className="whitespace-nowrap font-bold text-main">
                                                                                        {currencySymbol}
                                                                                        {parseFloat(descuento).toFixed(2)}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="p-3">
                                                                                    <div className="whitespace-nowrap text-slate-400">IVA:</div>
                                                                                </td>
                                                                                <td className="p-3 text-right">
                                                                                    <div className="whitespace-nowrap font-bold text-main">
                                                                                        {currencySymbol}
                                                                                        {parseFloat(ivaDet).toFixed(2)}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="bg-main p-3">
                                                                                    <div className="whitespace-nowrap font-bold text-white">Total:</div>
                                                                                </td>
                                                                                <td className="bg-main p-3 text-right">
                                                                                    <div className="whitespace-nowrap font-bold text-white">
                                                                                        {currencySymbol}
                                                                                        {parseFloat(total).toFixed(2)}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <footer className="fixed bottom-0 left-0 bg-slate-100 w-full text-neutral-600 text-center text-xs py-3">
                                    Supplier Company
                                    <span className="text-slate-300 px-2">|</span>
                                    info@company.com
                                    <span className="text-slate-300 px-2">|</span>
                                    +1-202-555-0106
                                </footer>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}




